export enum CurrencyCodesEnum {
  SCO = 'SCO',
  GCO = 'GCO',
};